import { CurrencyFormatter, CATEGORY_LIMIT } from "../chartHelper";
import { chartConfig } from "../chart.commonConfig";
import { lastPageChartConfig } from "./thirdPageChart.config";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FOURTH_BAR_CHART_HELPER = data => {
  const BAR_CHART = {
    chart: {
      ...chartConfig.chart,
      ...lastPageChartConfig.chart,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.LAST_PAGE.FOURTH._SUCCESS
          });
        }
      }
    },
    plotOptions: {
      series: {
        pointRange: 2
      }
    },
    title: {
      text: ""
    },
    subtitle: {
      text: ""
    },
    xAxis: {
      visible: false,
      categories: []
    },
    yAxis: {
      // Primary yAxis
      labels: {
        format: `{value}`,
        formatter: function() {
          return CurrencyFormatter(this.value / 100000).replace(/,/g, ".00");
        }
      },
      title: {
        text: "Anticipated Investment (Lakh Cr.)"
      },
      min: 0,
      max: 0,
      opposite: true,
      className: "bar-label"
    },
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: false
    },
    series: [
      {
        name: "Cost",
        data: []
      }
    ],
    plotOptions: {
      series: {
        groupPadding: 0,
        animation: false
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${BAR_CHART.xAxis.categories[this.colorIndex]}</b><br />
                <b>Projects: ${CurrencyFormatter(this.y / 100000).replace(
                  /,/g,
                  "."
                )} Lakh Cr</b>
              `;
      }
    }
  };

  try {
    const { projectSectorDTOS: list } = data;
    const costArr = [];
    const seriesArr = [];
    let otherProjectCost = 0;
    list.forEach(({ sector, projectCost, projectCount }, index) => {
      costArr.push(projectCost);
      if (index >= CATEGORY_LIMIT) {
        otherProjectCost += projectCost;
        seriesArr[CATEGORY_LIMIT] = seriesArr[CATEGORY_LIMIT] || {};
        seriesArr[CATEGORY_LIMIT]["name"] = "Others";
        seriesArr[CATEGORY_LIMIT]["data"] = [otherProjectCost];
        seriesArr[CATEGORY_LIMIT]["dataLabels"] = {
          y: -20,
          enabled: true,
          rotation: -90,
          formatter: function() {
            return CurrencyFormatter(this.y / 100000).replace(/,/g, ".");
          },
          style: {
            textOutline: "none"
          }
        };
      } else {
        seriesArr.push({
          name: sector,
          data: [projectCost],
          dataLabels: {
            y: -20,
            enabled: true,
            rotation: -90,
            formatter: function() {
              return CurrencyFormatter(this.y / 100000).replace(/,/g, ".");
            },
            style: {
              textOutline: "none"
            }
          }
        });
        BAR_CHART.xAxis.categories.push(sector);
      }
    });
    BAR_CHART.series = seriesArr;
    BAR_CHART.yAxis.max = Math.max(...costArr) + 500000;
    BAR_CHART.xAxis.categories[9] = "Others";
    return BAR_CHART;
  } catch (error) {
    console.error(error);
  }
};
